// Deterministic hash → fixed color palette. Used to give any label (a
// lead source name, a region code) the same recognizable color everywhere
// it appears — Weekly Inbound Digest's source chart and Region Health's
// region badges share this so the two panels visually tie together.
const PALETTE = [
  '#0ea5e9', '#f97316', '#22c55e', '#a855f7', '#ec4899', '#14b8a6', '#eab308',
  '#ef4444', '#6366f1', '#84cc16', '#06b6d4', '#d946ef', '#f59e0b', '#10b981',
];

export const colorForLabel = (label) => {
  let hash = 0;
  // Accumulate over a large modulus before reducing, so hash actually
  // reflects the whole string (mod'ing inside the loop by PALETTE.length
  // collapsed entropy to a handful of buckets, causing avoidable color
  // collisions across regions/sources).
  for (let i = 0; i < label.length; i++) hash = (hash * 31 + label.charCodeAt(i)) % 2147483647;
  return PALETTE[Math.abs(hash) % PALETTE.length];
};
